import { useQueryClient } from "@tanstack/react-query";
import { getQueryKey } from "@trpc/react-query";
import { RouterInputs, RouterOutputs, trpc } from "../trpc";

export type CreateShareInput = RouterInputs["canvas"]["createShare"];
export type CreateShareOutput = RouterOutputs["canvas"]["createShare"];

type CanvasDetail = RouterOutputs["canvas"]["get"];

export function useShareCanvas() {
  const queryClient = useQueryClient();

  return trpc.canvas.createShare.useMutation({
    // Optimistically update the cache to reflect the new public status
    onMutate(newShare) {
      const getCanvasQueryKey = getQueryKey(
        trpc.canvas.get,
        { id: newShare.id },
        "query",
      );

      const previous =
        queryClient.getQueryData<CanvasDetail>(getCanvasQueryKey);

      return {
        getCanvasQueryKey,
        previous,
      };
    },

    // Rollback the optimistic update in case of error
    onError(_error, _variables, context) {
      if (!context) {
        return;
      }

      queryClient.setQueryData<CanvasDetail>(
        context.getCanvasQueryKey,
        context.previous,
      );
    },

    // Work around issue where the upstream API takes a while to show the new public status
    onSuccess(_data, _variables, context) {
      if (!context || !context.previous) {
        return;
      }

      queryClient.setQueryData<CanvasDetail>(context.getCanvasQueryKey, {
        ...context.previous,
        isPublic: true,
      });
    },
  });
}
